export function getTelephoneCode(code: any, locale: any) {
  code = code.toString()
  if (code && (locale !== 'el' || code !== '30')) {
    return `+${code}`
  } else {
    return ''
  }
}
